/* eslint-disable no-undef */
/* eslint-disable no-multiple-empty-lines */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import DraggableChild from './child-component'
import DraggableContainer from './draggable-component'
import LayoutSelector from './layout-selector'
// import Buttons from '../../components/buttons/buttons'
// import CustomSelect from '../../utils/controls/custom-select'
import { RhyBusCustomSelect, RhyBusInputCheck } from '@rhybus/form-controls'
import { RhyBusButton } from '@rhybus/button'
// import { borderRadius, fontSizes, formSizes, gutterspace, borderType } from './element-options-list'
import { borderColors, borderRadius, ButtonColorFilters, fontFamily, fontSizes, formSizes, gutterspace, borderType } from './element-options-list'
import ElementOptions from './element-options'
import { UserInitalValue, PopupCloseContext } from '../formengine/contexts/popupclose-context'
import { UserDetailsContext } from '../utils/user-context'
import Modalpopup from '../formengine/modelpopup/modalpopup'
import { PageHeader } from '../formengine/header/page-header'
// import { ListNames } from '../../configuration'
// import { pnpAdd, pnpDelete } from '../../Global'
// import { getList } from '../../api/helpers'
// import { useFileContext } from '../fileContext/fileContext'
import { useFormBuilderContext } from './form-builder-context'
import { useLocation, useNavigate } from 'react-router-dom'
import { createRequirementSchema } from './create-requirement-schema'
import { createCaseSchema } from './create-case-schema'
import { createTrainingSchema } from './create-training-schema'
import { publishSchemaOnly, loadSchema, saveSchema } from './publish-utils'
import { publishSchema, loadActiveSchema, loadSchemaHistory } from '../services/formSchemaService'
import VersionHistoryPanel from './version-history-panel'
import DroppableArea from './droppable-area'
import { RhyBusPageHeader } from '@rhybus/header'
import { RhyBusCard } from '@rhybus/card'
import { RhyBusAlert } from '@rhybus/alert'

interface PageBuilderProps {
  previewForm?: React.ReactNode
  initialSchema?: { containersData: any[]; selectedLayout: any }
  pageTitle?: string
  formType?: string
}

const PAGE_TITLES: Record<string, string> = {
  grant:    'RhyBus Design Studio — Case',
  training: 'RhyBus Design Studio — Training',
}

const FORM_TYPE_ROUTES: Record<string, string> = {
  grant:    '/createcase',
  training: '/createtraining',
}

const PageBuilder: React.FC<PageBuilderProps> = ({ previewForm, initialSchema, pageTitle, formType }) => {
  const resolvedPageTitle = pageTitle ?? (formType ? PAGE_TITLES[formType] : undefined) ?? 'RhyBus Design Studio'
  // let { getChangedLabel} = props
  const [selectedContainer, setSelectedContainer] = useState<string | null>('droppable-area-default')
  const [layout, setLayout] = useState<number[] | null>(null)
  const [isPreview, setIsPreview] = useState(false)
  const [changedLabel, setChangedLabel] = useState<any>([])
  const navigate = useNavigate()
  const [publishStatus, setPublishStatus] = useState<'idle' | 'publishing' | 'success' | 'error'>('idle')
  const [noChangesMsg, setNoChangesMsg] = useState('')
  const [showNavigatePrompt, setShowNavigatePrompt] = useState(false)
  const [showHistoryModal, setShowHistoryModal] = useState(false)
  const [historyVersions, setHistoryVersions] = useState<any[]>([])
  const [historyLoading, setHistoryLoading] = useState(false)
  const [historyError, setHistoryError] = useState<string | null>(null)
  const { schema } = useFormBuilderContext()
  const { pageContextdets } = useContext(UserDetailsContext)
  const currentUser = (pageContextdets?.userDisplayName as string | undefined)?.trim() || ''
  const location = useLocation()
  const navState = location.state as { containersData?: any[]; containersDataRight?: any[]; selectedLayout?: any; formSettings?: any } | null
  const savedSchema = formType ? loadSchema(formType) : null
  // When a formType is active, only use that type's own saved schema or an empty canvas.
  // Never fall back to the shared context schema or createRequirementSchema for non-grant
  // types — that would bleed the grant form fields into case/training.
  const defaultSchemaForType = formType === 'grant'
    ? createRequirementSchema
    : formType === 'case'
      ? createCaseSchema
      : formType === 'training'
        ? createTrainingSchema
        : { containersData: [], selectedLayout: {} }
  const resolvedSchema = formType
    ? ((savedSchema as any) ?? defaultSchemaForType)
    : ((savedSchema as any) ?? initialSchema ?? schema ?? navState ?? createRequirementSchema)

  const [clickedId, setClickedId] = useState<number | null>(null)
  const [containerId, setContainerId] = useState<string>()
  const [containersData, setContainersData] = useState<
    { id: string; rowData: { id: string; isDataRow: boolean; childData: { id: string; type: string; label: string; isInfo: boolean; isMandatory: boolean, subChild?: any }[] }[] }[]
  >(resolvedSchema?.containersData ?? [])
  const [containersDataRight, setContainersDataRight] = useState<
    { id: string; rowData: { id: string; isDataRow: boolean; childData: { id: string; type: string; label: string; isInfo: boolean; isMandatory: boolean, subChild?: any }[] }[] }[]
  >([])
  const [selectedRowId, setSelectedRowId] = useState<string | any>()
  const [selectedWholeRowId, setSelectedWholeRowId] = useState<string | any>(null)
  const [selectedSubChild, setSelectedSubChild] = useState<string | null>(null)
  const [, setSelectedType] = useState<string | null>(null)
  const [selectedLayout, setSelectedLayout] = useState<any>(resolvedSchema?.selectedLayout ?? {})
  const [savedSnap, setSavedSnap] = useState<string>(
    () => JSON.stringify({ containersData: resolvedSchema?.containersData ?? [], selectedLayout: resolvedSchema?.selectedLayout ?? {} })
  )
  const [previousSelectedLayout, setPreviousSelectedLayout] = useState<string | null>(null)
  const [showRightColumn, setShowRightColumn] = useState(false)
  const fileHandleRef = useRef<any>(null)
  // const { formPageComponents } = useFileContext()


  const handleLayoutChange = (newLayout: number[]) => {
    setLayout(newLayout)
    setSelectedLayout((prev: any) => ({
      ...prev,
      [selectedWholeRowId]: newLayout
    }))
  }

  useEffect(() => {
    if (layout) {
      if (selectedLayout[selectedWholeRowId] && selectedLayout[selectedWholeRowId].length > 0) {
        switch (selectedLayout[selectedWholeRowId].length) {
          case 1:
            setPreviousSelectedLayout('single')
            break
          case 2:
            setPreviousSelectedLayout('two')
            break
          case 3:
            setPreviousSelectedLayout('three')
            break
          case 4:
            setPreviousSelectedLayout('four')
            break
          case 5:
            setPreviousSelectedLayout('five')
            break
          case 6:
            setPreviousSelectedLayout('six')
            break
          case 12:
            setPreviousSelectedLayout('twelve')
            break
          default:
            setPreviousSelectedLayout(null)
        }
      } else {
        setPreviousSelectedLayout('single')
      }
    } else {
      setPreviousSelectedLayout('single')
    }
  }, [layout, selectedWholeRowId, selectedLayout])

  const [, setCurrentbutton] = useState('')
  const [selectedChildId, setSelectedChildId] = useState<string | null>(null)

  const [child, setChild] = useState<any>(null)
  const setChildrenLengths = (data: any) => {
    if (data?.length > 0) {
      setChild(data)
    }
  }
  const onUpdate = (data: any, containerId: string, childId: string, rowId: string | undefined) => {
    if (data?.length > 0) {
      setChangedLabel(data)
      setContainersData((prevContainers) =>
        prevContainers?.map((container: any) => {
          if (container?.id === containerId) {
            return {
              ...container,
              rowData: container?.rowData.map((existingRow: any) =>
                existingRow.id === rowId
                  ? {
                    ...existingRow,
                    childData: existingRow.childData.map((child: any) => {
                      if (childId?.startsWith('subChild')) {
                        // Updating subChild if selectedSubChild is set
                        return {
                          ...child,
                          subChild: child?.subChild?.map((subChild: any) => {
                            const replacementSubChild = data?.find((childItem: any) =>
                              childItem?.id === selectedSubChild
                            ) || data?.find((childItem: any) =>
                              childItem?.subChild?.find((item: { id: string | null }) => item?.id === selectedSubChild)
                            )
                            return subChild.id === selectedSubChild && replacementSubChild
                              ? replacementSubChild
                              : subChild
                          }),
                        }

                      } else {
                        // Updating childData if selectedSubChild is not set
                        const replacementChild = data?.find((item: any) => item.id === childId)
                        return child.id === childId && replacementChild ? replacementChild : child
                      }
                    }),
                  }
                  : existingRow
              )
            }
          }
          return container
        })
      )
    }

  }
  const onClicked = (data: any) => {
    if (data?.length > 0) {
      setClickedId(data)
    }
  }
  const [selectChild, setSelectChild] = useState<any>(null)
  const setChildSelects = (childId: string | null, containerId: string, rowId: string, subchildId?: string) => {
    if (childId) {
      setSelectedContainer(null) // Deselect the container when a child is selected
    }
    setSelectChild(childId)
    setContainerId(containerId)
    setSelectedRowId(rowId)
    console.log(childId)
    let filteredChildren
    if (childId?.startsWith('subChild')) {
      const subChildrenArray = containersData?.find(({ id }) => containerId === id)?.rowData.find(({ id }) => rowId === id)?.childData
      const filteredArray = subChildrenArray?.find((item) => subchildId === item.id)?.subChild?.find((subChild: any) => childId === subChild.id)
      filteredChildren = [filteredArray]
    } else {
      filteredChildren = containersData?.find(({ id }) => containerId === id)?.rowData.find(({ id }) => rowId === id)?.childData || []
    }
    setChild(filteredChildren)
  }

  // Function to handle container selection
  // const handleContainerSelect = (containerId: string | null) => {
  //   if (containerId) {
  //     setSelectChild(null) // Deselect the child when a container is selected
  //   }
  //   setSelectedContainer(containerId)
  // }

  // const { multiplePopup, setMultiplePopup }: typeof UserInitalValue = useContext(PopupCloseContext)

  const buttonRef = useRef<HTMLButtonElement>(null)
  const buttonRef1 = useRef<HTMLButtonElement>(null)
  // for toggle popup, using below code
  // const handleTableButtonClick = (ele: string) => {
  //   if (ele === currentbutton) {
  //     setMultiplePopup(null)
  //     setCurrentbutton('')
  //   } else {
  //     setCurrentbutton(ele)
  //     setMultiplePopup(ele)
  //   }
  // }
  //-------------------------
  // useEffect(() => {
  //   const closePopupOnOtherButtonClick = (event: Event) => {
  //     const target = event.target as HTMLElement
  //     // If clicked element is a button or link, and it's NOT the table button, close the popup
  //     if (multiplePopup == target?.id) {
  //       setMultiplePopup(null)
  //       setCurrentbutton('')
  //     }
  //     else
  //       if (
  //         ((target.tagName === 'BUTTON' || target.tagName === 'A') || (target.closest('button') || target.closest('a'))) &&
  //         (buttonRef?.current || buttonRef1?.current) || (!buttonRef?.current?.contains(target) || !buttonRef1?.current?.contains(target))
  //       ) {
  //         setMultiplePopup(null)
  //       }
  //   }
    // Attach listeners to buttons and links excluding the one using `buttonRef`
  //   const buttonsAndLinks = document.querySelectorAll<HTMLButtonElement | HTMLAnchorElement>('button, a')
  //   buttonsAndLinks.forEach((element) => {
  //     if (element == buttonRef.current || element != buttonRef.current) {
  //      // element.addEventListener('click', closePopupOnOtherButtonClick)
  //     }
  //   })
  //   // Cleanup listeners when the component is unmounted or when activePopup changes
  //   return () => {
  //     buttonsAndLinks.forEach((element) => {
  //       if (element == buttonRef.current || element != buttonRef.current) {
  //         //element.removeEventListener('click', closePopupOnOtherButtonClick)
  //       }
  //     })
  //   }
  // }, [multiplePopup])

  const handleSettingChange = (key: string, value: string) => {
    setFormSettings((prev) => ({ ...prev, [key]: value }))
  }

  const [formSettings, setFormSettings] = useState({
    gutterspace: '',
    formsize: '',
    labelalignment: '',
    fontfamily: '',
    fontcolor: '',
    fontsize: '',
    bordercolor: '',
    bordertype: '',
    borderradius: '',
  })

  // Function to update container settings
  // const updateContainerSettings = (settings: typeof formSettings) => {
  //   console.log('Updating container settings with:', settings)
  // }

  // Handle the apply action and update the settings
  // const handleApply = () => {
  //   updateContainerSettings(formSettings)
  // }
  // const PopupWindow = (ele: string) => {
  //   setMultiplePopup((prevPopup: any) => (prevPopup === ele ? null : ele))
  // }
  const [handleAlign] = useState('')
  // const AlignHandler = (type?: string) => {
  //   if (type === 'leftAlign') {
  //     setAlignLeft('align-items-start')
  //   } else if (type === 'centerAlign') {
  //     setAlignLeft('align-items-center')
  //   } else if (type === 'rightAlign') {
  //     setAlignLeft('align-items-end')
  //   }
  // }

  const [previewContent, setPreviewContent] = useState<string>('')
  const droppableAreaRef = useRef<HTMLDivElement | null>(null)
  const [isModalPopup, setIsModalPopup] = useState(false)
  const handlePreview = () => {
    if (previewForm) {
      setIsPreview(prev => !prev)
      return
    }
    const droppableArea = droppableAreaRef.current
    setIsModalPopup(true)
    if (droppableArea) {
      const htmlContent = droppableArea.innerHTML
      setPreviewContent(htmlContent)
    }
  }

  const modalpopupClose = () => {
    setIsModalPopup(false)
  }

  const handleExport = async () => {
    // Get the HTML content of the DroppableArea (main-content ID)
    const droppableArea = document.getElementById('main-content')
    if (!droppableArea) {
      console.error('main-content element not found')
      return
    }

    // Extract the HTML content
    const htmlContent = droppableArea.innerHTML

    // Helper function to clean and format the HTML
    const cleanAndFormatHTML = (html: string): string => {
      return html
        .replace(/class="/g, 'className="') // Convert 'class' to 'className'
        .replace(/tabindex="0"/g, 'tabIndex={0}')
        .replace(/ style="[^"]*"/g, '') // Remove inline styles
        /// Remove <div> with unwanted classes (even empty)
        .replace(/<div[^>]*(class|className)="[^"]*\b(row-delete|element-buttons)\b[^"]*"[^>]*>(.*?)<\/div>/g, '')
        // Remove all <button>...</button>
        .replace(/<button[^>]*>[\s\S]*?<\/button>/g, '')
        .replace(/<(\w+)([^>]*)>/g, (match, tag, attributes) => {
          if (['img', 'input', 'br', 'hr'].includes(tag)) {
            return `<${tag} ${attributes.trim()} />`
          }
          return match
        })
        .trim()
    }

    const formattedContent = cleanAndFormatHTML(htmlContent)

    // Create a React component template
    const reactComponentContent = `
  import React from 'react';
  
  const Form: React.FC = () => {
    return (
      <div className="container">
        ${formattedContent}
      </div>
    );
  };
  
  export default Form;
  `.trim()

    // Send the content to the server
    try {
      const response = await fetch('../../api/form.ts', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ fileName: 'Form.tsx', content: reactComponentContent }),
      })

      if (response.ok) {
        console.log('File saved successfully')
      } else {
        console.error('Error saving file:', response.statusText)
      }
    } catch (error) {
      console.error('Error exporting content:', error)
    }
  }

  // const handleSave = async () => {
  //   // Prompt user for form name

  //   const formName = window.prompt('Enter a name for this form:', 'Untitled Form')
  //   if (formName === savedForms?.find((form: any) => form.name === formName)) {
  //     alert('A form with this name already exists. Please choose a different name.')
  //     return
  //   }
  //   if (!formName || formName.trim() === '') {
  //     alert('Form name is required')
  //     return
  //   }

  //   try {
  //     // Directly stringify formSettings (even with empty values)
  //     const formSettingsJson = JSON.stringify(formSettings)
  //     const leftContainersJson = JSON.stringify(containersData)
  //     const rightContainersJson = JSON.stringify(containersDataRight)
  //     const selectedLayoutJson = JSON.stringify(selectedLayout)

  //     // Collect form data for SharePoint
  //     const sharePointData = {
  //       FormName: formName.trim(),
  //       FormSettings: formSettingsJson,
  //       LeftContainers: leftContainersJson,
  //       RightContainers: rightContainersJson,
  //       SelectedLayout: selectedLayoutJson,
  //     }

  //     console.log('Saving FormSettings:', formSettingsJson)
  //     console.log('Complete data:', sharePointData)

  //     // Save to SharePoint SAVED_FORMS list using pnpAdd
  //     await pnpAdd(ListNames?.Saved_Components, sharePointData).then(async (data: any) => {
  //       // Also save to localStorage
  //       const localFormData = {
  //         id: `form_${Date.now()}`,
  //         name: formName.trim(),
  //         createdAt: new Date().toISOString(),
  //         updatedAt: new Date().toISOString(),
  //         pageTitle: pageTitle,
  //         pageIcon: pageIcon,
  //         formSettings: formSettings,
  //         leftContainers: containersData,
  //         rightContainers: containersDataRight,
  //         selectedLayout: selectedLayout,
  //       }
  //       const existingForms = JSON.parse(localStorage.getItem('savedForms') || '[]')
  //       const updatedForms = [...existingForms, localFormData]
  //       localStorage.setItem('savedForms', JSON.stringify(updatedForms))

  //       // Update state immediately to show the saved form
  //       setSavedForms(updatedForms)
  //       setIsForm(!isForm)

  //       alert(`Form "${formName}" saved successfully!`)
  //       console.log('Form saved to SharePoint:', sharePointData)
  //     })
  //   } catch (error) {
  //     console.error('Error saving form:', error)
  //     alert('Error saving form. Please try again.')
  //   }
  // }
  // Returns only the fields JSX (no imports, no component wrapper).
  // Used by handlePublish for surgical in-place updates via FORM_ENGINE markers.
  const generateFieldsJsx = (): string => {
    const serializeChildPlain = (ch: any, colClass: string): string => {
      const isMandatoryJsx = ch.isMandatory ? '{true}' : '{false}'
      const label: string = ch.label || ''
      const infoProp = label ? ` info="${label}"` : ''
      const id: string = ch.id || ''
      const placeholder: string = ch.placeholder || `Enter ${label}`
      const readonlyProp = ch.readonly ? ' readOnly={true}' : ''
      const disabledProp = ch.disabled ? ' disabled={true}' : ''
      const defaultValueProp = ch.value ? ` defaultValue="${ch.value}"` : ''
      switch (ch.type) {
        case 'Input': case 'text': case 'email': case 'number':
          return `<div className="${colClass}">\n          <RhyBusInputText id="input-${id}" name="${label}" label="${label}" placeholder="${placeholder}" isMandatory=${isMandatoryJsx}${infoProp}${readonlyProp}${disabledProp}${defaultValueProp} />\n        </div>`
        case 'Radio': case 'radio':
          return `<div className="${colClass}">\n          <div className="form-vertical">\n            <RhyBusLabel htmlFor="radio-${id}" label="${label}" isMandatory=${isMandatoryJsx}${infoProp} />\n            <div className="d-flex gap-3">\n              <RhyBusInputCheck id="radio-${id}-yes" name="${id}" type="radio" label="Yes" />\n              <RhyBusInputCheck id="radio-${id}-no" name="${id}" type="radio" label="No" />\n            </div>\n          </div>\n        </div>`
        case 'checkbox':
          return `<div className="${colClass}">\n          <RhyBusInputCheck id="inputcheck-${id}" name="${label}" label="${label}" isMandatory=${isMandatoryJsx}${infoProp} />\n        </div>`
        case 'Select':
          return `<div className="${colClass}">\n          <RhyBusCustomSelect id="select-${id}" name="${label}" label="${label}" placeholder="${placeholder || `Select ${label}`}" isMandatory=${isMandatoryJsx}${infoProp}${disabledProp} options={[]} />\n        </div>`
        case 'DatePicker':
          return `<div className="${colClass}">\n          <div className="form-vertical">\n            <RhyBusLabel htmlFor="date-${id}" label="${label}" isMandatory=${isMandatoryJsx}${infoProp} />\n            <RhyBusDatePicker id="date-${id}" placeholder="MM/DD/YYYY" isMandatory=${isMandatoryJsx} mode="date"${disabledProp} />\n          </div>\n        </div>`
        case 'Textarea':
          return `<div className="${colClass}">\n          <RhyBusTextArea id="textarea-${id}" name="${label}" label="${label}" placeholder="${placeholder}" isMandatory=${isMandatoryJsx}${infoProp}${readonlyProp}${disabledProp} rows={5} />\n        </div>`
        case 'RichText':
          return `<div className="${colClass}">\n          <Richtext label="${label}" placeholder="${placeholder}" isMandatory=${isMandatoryJsx} inputProps={{id:"richtext-${id}"}} formClassName="form-vertical" />\n        </div>`
        case 'uploadfile':
          return `<div className="${colClass}">\n          <RhyBusFileUpload label="${label || 'Attach File(s)'}" hint="Upload the files which are in the .png, .jpeg, .xlsx,.txt .docx, .pdf files and special characters will not be used in the document names. Maximum size for file is 25MB. Limit is up to 10 files per screen." note="Screenshots need to be saved locally before uploading into system." mandatory=${isMandatoryJsx}${infoProp} />\n        </div>`
        case 'PeoplePicker': {
          const mandatorySpan = ch.isMandatory ? '\n              <span className="mandatory ms-1">*</span>' : ''
          const tooltipBlock = infoProp ? `\n              <RhyBusToolTip content="${label}" placement="top">\n                <span className="icon-rb-info ms-1"></span>\n              </RhyBusToolTip>` : ''
          return `<div className="${colClass}">\n          <div className="sppeoplepicker">\n            <label htmlFor="people-picker-input" className="">\n              ${label}${mandatorySpan}${tooltipBlock}\n            </label>\n            <RhybusPeoplePicker\n              onSelect={(_person: any) => {}}\n              className="d-flex flex-column mt-1"\n              onChange={() => {}}\n              peoplePickerData={[]}\n            />\n          </div>\n        </div>`
        }
        case 'Button':
          return `<div className="${colClass}">\n          <RhyBusButton label="${label}" />\n        </div>`
        case 'SectionHeader':
          return `<div className="${colClass}">\n          <div className="w-100" style={{backgroundColor:'#EEF0FF',borderRadius:'6px',padding:'8px 12px'}}>${label}</div>\n        </div>`
        case 'ContractDurationHeader':
          return `<div className="${colClass}">\n          <div className="d-flex align-items-center justify-content-between w-100" style={{backgroundColor:'#434D8A',borderTopLeftRadius:'9px',borderTopRightRadius:'9px',padding:'8px 16px'}}>\n            ${label}\n            <RhyBusButton variant="text" label="Add" leftIcon="icon-rb-add font-12 whitetext" />\n          </div>\n        </div>`
        case 'SubSectionHeader':
          return `<div className="${colClass}">\n          <div className="w-100" style={{backgroundColor:'#EFF7FF',color:'#004993',borderRadius:'6px',padding:'8px 12px'}}>${label}</div>\n        </div>`
        default:
          return `<div className="${colClass}"></div>`
      }
    }
    return containersData.map((container: any) => {
      const rows = container.rowData.map((row: any) => {
        const layout = selectedLayout[row.id]
        const children = row.childData.map((ch: any, idx: number) => {
          const colNum = layout ? layout[idx % layout.length] : 12
          const colClass = colNum === 20 ? `col-12 col-md-6 col-lg-${colNum}per` : `col-12 col-md-6 col-lg-${colNum}`
          return serializeChildPlain(ch, colClass)
        }).join('\n        ')
        return `<div id="${row.id}" className="row p-relative ${(formSettings.gutterspace as any)?.value || 'g-2'} ${(formSettings.formsize as any)?.value || 'form-md'}  ${(formSettings.fontsize as any)?.value || ''} ${(formSettings.bordercolor as any)?.value || ''} ${(formSettings.fontcolor as any)?.value || 'darktext'}">\n        ${children}\n      </div>`
      }).join('\n      ')
      return `<div id="${container.id}" className="row ${formSettings.gutterspace || 'g-2'} ${(formSettings.formsize as any)?.value || 'form-md'} ${(formSettings.fontsize as any)?.value || ''} ${(formSettings.bordercolor as any)?.value || ''} ${(formSettings.fontcolor as any)?.value || 'darktext'}">\n      ${rows}\n    </div>`
    }).join('\n    ')
  }

  const generateFormCode = (): string => {
    const usedTypes = new Set<string>()

    const serializeChild = (ch: any, colClass: string): string => {
      const isMandatoryJsx = ch.isMandatory ? '{true}' : '{false}'
      const label: string = ch.label || ''
      const infoProp = label ? ` info="${label}"` : ''
      const id: string = ch.id || ''
      const placeholder: string = ch.placeholder || `Enter ${label}`
      const readonlyProp = ch.readonly ? ' readOnly={true}' : ''
      const disabledProp = ch.disabled ? ' disabled={true}' : ''
      const defaultValueProp = ch.value ? ` defaultValue="${ch.value}"` : ''

      switch (ch.type) {
        case 'Input':
        case 'text':
        case 'email':
        case 'number':
          usedTypes.add('RhyBusInputText')
          return `<div className="${colClass}">\n          <RhyBusInputText id="input-${id}" name="${label}" label="${label}" placeholder="${placeholder}" isMandatory=${isMandatoryJsx}${infoProp}${readonlyProp}${disabledProp}${defaultValueProp} />\n        </div>`
        case 'Radio':
        case 'radio':
          usedTypes.add('RhyBusInputCheck')
          usedTypes.add('RhyBusLabel')
          return `<div className="${colClass}">\n          <div className="form-vertical">\n            <RhyBusLabel htmlFor="radio-${id}" label="${label}" isMandatory=${isMandatoryJsx}${infoProp} />\n            <div className="d-flex gap-3">\n              <RhyBusInputCheck id="radio-${id}-yes" name="${id}" type="radio" label="Yes" />\n              <RhyBusInputCheck id="radio-${id}-no" name="${id}" type="radio" label="No" />\n            </div>\n          </div>\n        </div>`
        case 'checkbox':
          usedTypes.add('RhyBusInputCheck')
          return `<div className="${colClass}">\n          <RhyBusInputCheck id="inputcheck-${id}" name="${label}" label="${label}" isMandatory=${isMandatoryJsx}${infoProp} />\n        </div>`
        case 'Select':
          usedTypes.add('RhyBusCustomSelect')
          return `<div className="${colClass}">\n          <RhyBusCustomSelect id="select-${id}" name="${label}" label="${label}" placeholder="${placeholder || `Select ${label}`}" isMandatory=${isMandatoryJsx}${infoProp}${disabledProp} options={[]} />\n        </div>`
        case 'DatePicker':
          usedTypes.add('RhyBusDatePicker')
          usedTypes.add('RhyBusLabel')
          return `<div className="${colClass}">\n          <div className="form-vertical">\n            <RhyBusLabel htmlFor="date-${id}" label="${label}" isMandatory=${isMandatoryJsx}${infoProp} />\n            <RhyBusDatePicker id="date-${id}" placeholder="MM/DD/YYYY" isMandatory=${isMandatoryJsx} mode="date"${disabledProp} />\n          </div>\n        </div>`
        case 'Textarea':
          usedTypes.add('RhyBusTextArea')
          return `<div className="${colClass}">\n          <RhyBusTextArea id="textarea-${id}" name="${label}" label="${label}" placeholder="${placeholder}" isMandatory=${isMandatoryJsx}${infoProp}${readonlyProp}${disabledProp} rows={5} />\n        </div>`
        case 'RichText':
          usedTypes.add('Richtext')
          return `<div className="${colClass}">\n          <Richtext label="${label}" placeholder="${placeholder}" isMandatory=${isMandatoryJsx} inputProps={{id:"richtext-${id}"}} formClassName="form-vertical" />\n        </div>`
        case 'uploadfile':
          usedTypes.add('RhyBusFileUpload')
          return `<div className="${colClass}">\n          <RhyBusFileUpload label="${label || 'Attach File(s)'}" hint="Upload the files which are in the .png, .jpeg, .xlsx,.txt .docx, .pdf files and special characters will not be used in the document names. Maximum size for file is 25MB. Limit is up to 10 files per screen." note="Screenshots need to be saved locally before uploading into system." mandatory=${isMandatoryJsx}${infoProp} />\n        </div>`
        case 'PeoplePicker': {
          usedTypes.add('RhybusPeoplePicker')
          usedTypes.add('RhyBusToolTip')
          const mandatorySpan = ch.isMandatory ? '\n              <span className="mandatory ms-1">*</span>' : ''
          const tooltipBlock = infoProp ? `\n              <RhyBusToolTip content="${label}" placement="top">\n                <span className="icon-rb-info ms-1"></span>\n              </RhyBusToolTip>` : ''
          return `<div className="${colClass}">\n          <div className="sppeoplepicker">\n            <label htmlFor="people-picker-input" className="">\n              ${label}${mandatorySpan}${tooltipBlock}\n            </label>\n            <RhybusPeoplePicker\n              onSelect={(_person: any) => {}}\n              className="d-flex flex-column mt-1"\n              onChange={() => {}}\n              peoplePickerData={[]}\n            />\n          </div>\n        </div>`
        }
        case 'Button':
          usedTypes.add('RhyBusButton')
          return `<div className="${colClass}">\n          <RhyBusButton label="${label}" />\n        </div>`
        case 'SectionHeader':
          return `<div className="${colClass}">\n          <div className="w-100" style={{backgroundColor:'#EEF0FF',borderRadius:'6px',padding:'8px 12px'}}>${label}</div>\n        </div>`
        case 'ContractDurationHeader':
          usedTypes.add('RhyBusButton')
          return `<div className="${colClass}">\n          <div className="d-flex align-items-center justify-content-between w-100" style={{backgroundColor:'#434D8A',borderTopLeftRadius:'9px',borderTopRightRadius:'9px',padding:'8px 16px'}}>\n            ${label}\n            <RhyBusButton variant="text" label="Add" leftIcon="icon-rb-add font-12 whitetext" />\n          </div>\n        </div>`
        case 'SubSectionHeader':
          return `<div className="${colClass}">\n          <div className="w-100" style={{backgroundColor:'#EFF7FF',color:'#004993',borderRadius:'6px',padding:'8px 12px'}}>${label}</div>\n        </div>`
        default:
          return `<div className="${colClass}"></div>`
      }
    }

    const formattedContent = containersData.map((container: any) => {
      const rows = container.rowData.map((row: any) => {
        const layout = selectedLayout[row.id]
        const children = row.childData.map((ch: any, idx: number) => {
          const colNum = layout ? layout[idx % layout.length] : 12
          const colClass = colNum === 20
            ? `col-12 col-md-6 col-lg-${colNum}per`
            : `col-12 col-md-6 col-lg-${colNum}`
          return serializeChild(ch, colClass)
        }).join('\n        ')
        return `<div id="${row.id}" className="row p-relative ${(formSettings.gutterspace as any)?.value || 'g-2'} ${(formSettings.formsize as any)?.value || 'form-md'}  ${(formSettings.fontsize as any)?.value || ''} ${(formSettings.bordercolor as any)?.value || ''} ${(formSettings.fontcolor as any)?.value || 'darktext'}">\n        ${children}\n      </div>`
      }).join('\n      ')
      return `<div id="${container.id}" className="row ${formSettings.gutterspace || 'g-2'} ${(formSettings.formsize as any)?.value || 'form-md'} ${(formSettings.fontsize as any)?.value || ''} ${(formSettings.bordercolor as any)?.value || ''} ${(formSettings.fontcolor as any)?.value || 'darktext'}">\n      ${rows}\n    </div>`
    }).join('\n    ')

    const formControls = ['RhyBusInputText', 'RhyBusCustomSelect', 'RhyBusTextArea', 'RhyBusInputCheck', 'RhyBusDatePicker', 'RhyBusLabel']
      .filter(c => usedTypes.has(c))

    const importLines: string[] = ['import React from \'react\'']
    if (formControls.length) importLines.push(`import { ${formControls.join(', ')} } from '@rhybus/form-controls'`)
    if (usedTypes.has('RhyBusButton')) importLines.push('import { RhyBusButton } from \'@rhybus/button\'')
    if (usedTypes.has('RhyBusFileUpload')) importLines.push('import { RhyBusFileUpload } from \'@rhybus/file-upload\'')
    if (usedTypes.has('RhybusPeoplePicker')) importLines.push('import { RhybusPeoplePicker } from \'@rhybus/people-picker\'')
    if (usedTypes.has('RhyBusToolTip')) importLines.push('import { RhyBusToolTip } from \'@rhybus/tooltip\'')
    if (usedTypes.has('Richtext')) importLines.push('import Richtext from \'./richtext\'')

    const fileContent = `${importLines.join('\n')}
import { useEffect, useMemo, useRef, useState } from 'react'
import { useParams , useNavigate} from 'react-router-dom'
import { RhyBusCard } from '@rhybus/card'
import { RhyBusButton } from '@rhybus/button'
import { RhyBusAlert } from '@rhybus/alert'
import Instructions from '../../utils/controls/instructions/instructions'
import { RhyBusValidationSummary } from '@rhybus/validation-summary'
import { UPDATE_ALERT, fields } from '../../config/configuration'
import { useForm } from '../../services/form'
import { useFormMetadataOptions } from '../../services/metadataManagement'
import { useTooltipResolver } from '../../services/use-tooltip-resolver'
const Form: React.FC = () => {
 const { itemGuid } = useParams()
    const navigate = useNavigate()
    const { formRef, values, handleChange, handleSave, handleCancel, handleSubmit, handleUpdate, showCancelAlert, setShowCancelAlert, showInstructions, setShowInstructions, validationMsgs, setValidationMsgs, focusField, position, loadFormByGuid, hasEditValueChanges, isEditMode, formHydrationVersion } = useForm()
    const resolveTooltip = useTooltipResolver()
    const [showNoChangesAlert, setShowNoChangesAlert] = useState(false)
    const [showSuccessAlert, setShowSuccessAlert] = useState(false)
    const fileMapRef = useRef<Record<string, File[]>>({})
    const { branchOptions, divisionOptions, productOptions, tbmOptions } = useFormMetadataOptions()

    const dynamicFields = useMemo(() =>
        fields.map(f => {
            if (f.key === 'branch' && branchOptions.length) return { ...f, options: branchOptions }
            if (f.key === 'division' && divisionOptions.length) return { ...f, options: divisionOptions }
            if (f.key === 'product' && productOptions.length) return { ...f, options: productOptions }
            if (f.key === 'TBM' && tbmOptions.length) return { ...f, options: tbmOptions }
            return f
        }),
        [branchOptions, divisionOptions, productOptions, tbmOptions]
    )

    useEffect(() => {
        if (!itemGuid) return
        loadFormByGuid(itemGuid)
    }, [itemGuid, loadFormByGuid])

    const registerFieldElement = (fieldKey: string, el: any) => {
        const prev = formRef.current[fieldKey]
        formRef.current[fieldKey] = { ...(typeof prev === 'object' && prev ? prev : {}), el }
    }

    const captureActualFiles = (fieldKey: string, e: any) => {
        const target = e.target as HTMLInputElement
        if (target?.type === 'file' && target.files) {
            fileMapRef.current[fieldKey] = Array.from(target.files)
        }
    }

    const onFileChange = (fieldKey: string, strippedFiles: any[]) => {
        const actualFiles = fileMapRef.current[fieldKey] ?? []
        const merged = strippedFiles.map((stripped: any) => {
            if (!stripped || stripped instanceof File) return stripped
            const match = actualFiles.find(
                (f: File) => f.name === (stripped.name || stripped.FileName) && f.size === stripped.size
            )
            return match ?? stripped
        })
        fileMapRef.current[fieldKey] = []
        handleChange(fieldKey, merged)
    }

    const isActuallyEditMode = isEditMode
    const formTitle = isActuallyEditMode ? 'Update Case' : 'Initialize Case'
    const primaryActionLabel = isActuallyEditMode ? 'Update' : 'Save'
    const primaryActionIcon = isActuallyEditMode ? 'icon-rb-arrow-repeat' : 'icon-rb-saved color-primary'
    const submitActionLabel = isActuallyEditMode ? 'Update' : 'Submit'
    const submitActionIcon = isActuallyEditMode ? 'icon-rb-arrow-repeat' : 'icon-rb-checked'

    const onUpdate = async (position: 'top' | 'bottom') => {
        if (!hasEditValueChanges()) {
            setShowNoChangesAlert(true)
            return
        }
        await handleUpdate(position)
    }

    const submitActionHandlerTop = async () => {

        const response =
            isActuallyEditMode
            ? await onUpdate('top')
            : await handleSubmit('top')

        if (response) {
            setShowSuccessAlert(true)
        }
    }
    const submitActionHandlerBottom = async () => {

        const response =
            isActuallyEditMode
            ? await onUpdate('bottom')
            : await handleSubmit('bottom')

        if (response) {
            setShowSuccessAlert(true)
        }
    }
    const saveActionHandlerTop = () => isActuallyEditMode ? onUpdate('top') : handleSave('top')
    const saveActionHandlerBottom = () => isActuallyEditMode ? onUpdate('bottom') : handleSave('bottom')
  return (
  <>
   <RhyBusAlert
            show={showCancelAlert}
            size="md"
            variant="confirm"
            message={'Are you sure you want to cancel? Unsaved changes will be lost.'}
            confirmLabel="Yes"
            cancelLabel="No"
            okIcon="icon-rb-checked"
            cancelIcon="icon-rb-close"
            onConfirm={() => setShowCancelAlert(false)}
            onCancel={() => setShowCancelAlert(false)}
        />
        <RhyBusAlert
            show={showNoChangesAlert}
            variant="confirm"
            message={UPDATE_ALERT}
            confirmLabel="OK"
            onConfirm={() => setShowNoChangesAlert(false)}
        />
        <RhyBusAlert
            show={showSuccessAlert}
            size="md"
            variant="success"
            title="Success"
            message="Grant submitted successfully."
            confirmLabel="OK"
            okIcon="icon-rb-checked"
            onConfirm={() => {
                setShowSuccessAlert(false)
                navigate('/createcase')
            }}
            onClose={() => {
                setShowSuccessAlert(false)
                navigate('/createcase')
            }}
        />
     <div className="container">
            <div className="row">
                <div className="col-12">
                    <RhyBusCard
                        cardSize='lg'
                        isTitleBorder={true}
                        cardHeaderLeft={
                            <div className="d-flex align-items-center gap-2">
                                <h2 className='' tabIndex={0} aria-label={formTitle}><span className="icon-rb-create-form color-primary font-14 me-1" aria-hidden="true"></span>{formTitle}</h2>
                                <RhyBusButton variant="primary" label="Instructions" className="" rightIcon={showInstructions ? 'icon-rb-arrow-up' : 'icon-rb-arrow-down'} size="sm" onClick={() => setShowInstructions((s: boolean) => !s)} />
                            </div>
                        }
                        cardHeaderRight={
                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                <RhyBusButton variant="primary" label="Cancel" leftIcon="icon-rb-close font-11 color-primary" onClick={() => handleCancel()} style={{ '--rb-btn-text': '#030332', '--rb-btn-hover-bg': '#fff', '--rb-btn-bg': '#fff', '--rb-btn-border': '#C0CAD8', '--rb-btn-hover-border': '#C0CAD8' }} />
                                <RhyBusButton variant="primary" label={primaryActionLabel} leftIcon={primaryActionIcon} onClick={saveActionHandlerTop} style={{ '--rb-btn-text': '#030332', '--rb-btn-hover-bg': '#fff', '--rb-btn-bg': '#fff', '--rb-btn-border': '#C0CAD8', '--rb-btn-hover-border': '#C0CAD8' }} />
                                <RhyBusButton variant="primary" label={submitActionLabel} leftIcon={submitActionIcon} onClick={submitActionHandlerTop} />
                            </div>
                        }
                        cardbodyclassName='pt-2'
                        cardBody={
                            <>
                        {showInstructions && <Instructions />}
                                                                {validationMsgs && validationMsgs.length > 0 && position === 'top' && (
                                                                        <RhyBusValidationSummary
                                                                            errors={validationMsgs.map((m: any) => ({ name: m.key, label: m.text }))}
                                                                            variant="info"
                                                                            showClose={true}
                                                                            onClose={() => setValidationMsgs([])}
                                                                            onErrorClick={(error: any) => focusField(error.name)}
                                                                        />
                                                                )}
    ${formattedContent}
    {/* Section A ends*/}
                                    {validationMsgs && validationMsgs.length > 0 && position === 'bottom' && (
                                        <div className='mt-3'>
                                            <RhyBusValidationSummary
                                                errors={validationMsgs.map((m: any) => ({ name: m.key, label: m.text }))}
                                                variant="info"
                                                showClose={true}
                                                onClose={() => setValidationMsgs([])}
                                                onErrorClick={(error: any) => focusField(error.name)}
                                            />
                                        </div>
                                    )}
    </>
    }
                        cardFooter={
                            <div className='d-flex justify-content-end w-100 gap-2 flex-wrap'>
                                <RhyBusButton variant="primary" label="Cancel" leftIcon="icon-rb-close font-11 color-primary" onClick={() => handleCancel()} style={{ '--rb-btn-text': '#030332', '--rb-btn-hover-bg': '#fff', '--rb-btn-bg': '#fff', '--rb-btn-border': '#C0CAD8', '--rb-btn-hover-border': '#C0CAD8' }} />
                                <RhyBusButton variant="primary" label={primaryActionLabel} leftIcon={primaryActionIcon} onClick={saveActionHandlerBottom} style={{ '--rb-btn-text': '#030332', '--rb-btn-hover-bg': '#fff', '--rb-btn-bg': '#fff', '--rb-btn-border': '#C0CAD8', '--rb-btn-hover-border': '#C0CAD8' }} />
                               <RhyBusButton variant="primary" label={submitActionLabel} leftIcon={submitActionIcon} onClick={submitActionHandlerBottom} />
                            </div>
                        }
                    />
                </div>
            </div>
        </div>
        </>
  )
}

export default Form`
    return fileContent
  }

  const handleSaveToFolder = async () => {
    const fileContent = generateFormCode()
    try {
      if ('showSaveFilePicker' in window) {
        if (!fileHandleRef.current) {
          fileHandleRef.current = await (window as any).showSaveFilePicker({
            suggestedName: 'createform.tsx',
            types: [{ description: 'TypeScript React File', accept: { 'text/plain': ['.tsx'] } }],
          })
        }
        const writable = await fileHandleRef.current.createWritable({ keepExistingData: false })
        await writable.write(fileContent)
        await writable.close()
      } else {
        const blob = new Blob([fileContent], { type: 'text/plain' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = 'createform.tsx'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(link.href)
      }
    } catch (error: any) {
      if (error?.name === 'AbortError') {
        fileHandleRef.current = null
      } else if (error?.name === 'InvalidStateError' || error?.name === 'NotAllowedError') {
        fileHandleRef.current = null
      } else {
        console.error('Error saving file:', error)
      }
    }
  }
  const handleSaveOld = () => {
    if (!isDirty) {
      setNoChangesMsg('No changes to save')
      setTimeout(() => setNoChangesMsg(''), 2500)
      return
    }
    setNoChangesMsg('')
    setSavedSnap(JSON.stringify({ containersData, selectedLayout }))
    const droppableArea = document.getElementById('main-content')
    if (!droppableArea) {
      console.error('main-content element not found')
      return
    }


    // Extract HTML content
    const htmlContent = droppableArea.innerHTML

    // Define class names to remove based on ID patterns
    const classRemovals = {
      row: ['border-primary', 'border-radius', 'border-1'],
      container: ['bg-light', 'border-radius', 'undefined', 'border-1', 'row', 'g-2', 'p-2'],
    }

    // Function to replace native elements with React components
    const processedElements = new WeakSet<Element>() // Track processed elements

    const replaceWithReactComponent = (element: Element): string | null => {
      // if (processedElements.has(element)) {
      //   return null // Skip already processed elements
      // }

      // Extract attributes
      const id = element.getAttribute('id')?.trim() || `custom-select-${Date.now()}`
      const name = element.getAttribute('name')?.trim() || (element as any).title?.trim()
      const value = element.getAttribute('value')?.trim() || ''

      let label = (element as any).title

      // If no placeholder, try getting the selected <option> text
      if (!label && element.tagName.toLowerCase() === 'select') {
        const selectedOption = element.querySelector('option[selected]')
        label = selectedOption ? selectedOption.textContent?.trim() || '' : 'Select an option'
      }

      // If React Select, try to find its displayed label inside child divs
      if (!label && element.classList.contains('css-b62m3t-container')) {
        const selectedLabel = element?.parentElement?.getElementsByTagName('label')
        label = selectedLabel ? selectedLabel?.[0].innerText || 'Select an option' : 'Select an option'
      }

      // Debugging: Log extracted values
      console.log('Processing:', element)
      console.log('Extracted Values -> ID:', id, 'Name:', name, 'Value:', value, 'Label:', label)

      let reactComponent = ''

      if (element.classList.contains('css-b62m3t-container')) {
        console.log('Replacing React Select:', element)
        processedElements.add(element)
        return `<CustomSelect key="${id}" id="${id}" options={[]} value={[]} label="${label}" />`
      }

      if (element.closest('.css-b62m3t-container')) {
        return null // Skip processing children of React Select
      }
      /// Skip Add Row button
      if (element?.tagName?.toLowerCase() === 'button' && element?.['ariaLabel'] === 'Add Row') {
        return null
      }
      if (!label && element?.tagName?.toLowerCase() === 'button' && element?.['ariaLabel'] !== 'Add Row') {
        label = element?.['ariaLabel'] || ''
      }
      if (element?.className === 'attachments') {
        const safeLabel = label && label !== 'undefined' ? label : 'Upload File'
        reactComponent = `<RhyBusFileUpload inputProps={{ id: '${id}', name: '${name}' }} label="${safeLabel}" />`
      }
      if ((element as any)?.type === 'checkbox') {
        reactComponent = `<InputCheck key="${id}" id="${id}" name="${name}" label="${label}" />`
      }
      const tag = element.tagName.toLowerCase()
      if (element?.className !== 'attachments' && (element as any)?.type !== 'checkbox') {
        switch (tag) {
          case 'input':
            reactComponent = `<RhyBusInputText key="${id}" id="${id}" name="${name}" valueKey="${value}" label="${label ? label : 'Text-Feild'}" />`
            break
          case 'select':
            reactComponent = `<RhyBusCustomSelect key="${id}" id="${id}" name="${name}" valueKey="${value}" label="${label ? label : 'Select an option'}" />`
            break
          case 'textarea':
            reactComponent = `<RhyBusInputTextarea key="${id}" id="${id}" name="${name}" valueKey="${value}" label="${label ? label : 'Text-Feild'}" />`
            break
          case 'button':
            reactComponent = `<RhyBusButton id="${id}" name="${name}" label="${label ? label : 'Button'}" />`
            break
          case 'fileupload':
            reactComponent = `<RhyBusFileUpload inputProps={{ id: '${id}', name: '${name}' }} label="${label ? label : 'Upload File'}" />`
            break
          case 'DatePicker':
            reactComponent = `<RhyBusDatePicker key="${id}" id="${id}" name="${name}" valueKey="${value}" label="${label ? label : 'Date'}" />`
            break
          default:
            return element.outerHTML // Keep original HTML if no match
        }
      }
      processedElements.add(element)
      return reactComponent
    }

    // Helper function to clean and format the HTML
    const cleanAndFormatHTML = (html: string): string => {
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, 'text/html')

      // Remove all label elements
      doc.querySelectorAll('label').forEach((el: any) => {
        if (!el?.innerText?.includes?.('Select') && !el?.innerText?.includes('fileupload') && !el?.innerText?.trim()?.includes('Upload File') && !el?.innerText?.includes('Choose/Drag files')) {
          el.remove()
        }
      }
      )

      doc.querySelectorAll('.element-buttons, CustomButton').forEach(el => el.remove())

      // Replace form elements with React components
      doc.querySelectorAll('input, label, customselect, CustomButton, select,textarea, button, .css-b62m3t-container, .react-select__input').forEach((el: any) => {
        el.outerHTML = replaceWithReactComponent(el)
      })

      return doc.body.innerHTML
        .replace(/class="/g, 'className="')
        .replace(/<buttons/g, '<Buttons')
        .replace(/<\/buttons>/g, '</Buttons>')
        .replace(/for="/g, 'htmlFor="')
        .replace(/maxlength="255"/g, 'maxLength={255}')
        .replace(/rows="(\d+)"/g, 'rows={$1}')
        .replace(/ style="[^"]*"/g, '') // Remove inline styles
        .replace(/<RhyBusInputText/g, '<RhyBusInputText')
        .replace(/><\/RhyBusInputText>/gi, ' />')
        .replace(/<RhyBusInputCheck/g, '<RhyBusInputCheck')
        .replace(/<\/RhyBusInputCheck>/g, '</RhyBusInputCheck>')
        .replace(/<RhyBusRichtextV1/g, '<RhyBusRichtextV1')
        .replace(/<\/RhyBusRichtextV1>/g, '</RhyBusRichtextV1>')
        // .replace(/<\/RhyBusInputText>/g, '</RhyBusInputText>')
        .replace(/<RhyBusCustomSelect/g, '<RhyBusCustomSelect')
        .replace(/><\/RhyBusCustomSelect>/gi, ' />')
        .replace(/<RhyBusDatePicker/g, '<RhyBusDatePicker')
        .replace(/<\/RhyBusDatePicker>/g, '</RhyBusDatePicker>')
        .replace(/<RhyBusInputTextarea/g, '<RhyBusInputTextarea')
        .replace(/<\/RhyBusInputTextarea>/g, '</RhyBusInputTextarea>')
        .replace(/<RhyBusCustomButton/g, '<RhyBusCustomButton')
        .replace(/<\/RhyBusCustomButton>/g, '</RhyBusCustomButton>')
        .replace(/<RhyBusFileUpload/g, '<RhyBusFileUpload')
        .replace(/<\/RhyBusFileUpload>/g, '</RhyBusFileUpload>')
        .replace(/tabindex="0"/g, 'tabIndex={0}')
        .replace(/(<RhyBusCustomSelect[^>]*?)value="\{?\[\]\}?"/g, '$1value={[]}')
        .replace(/(<RhyBusCustomSelect[^>]*?)options="\{?\[\]\}?"/g, '$1options={[]}')
        // Remove <div> with unwanted classes (even empty)
        .replace(/<div[^>]*(class|className)="[^"]*\b(row-delete|element-buttons)\b[^"]*"[^>]*>(.*?)<\/div>/g, '')
        // Remove all <button>...</button>
        .replace(/<button[^>]*>[\s\S]*?<\/button>/g, '')
        .replace(
          /inputprops="\{\{".*?id:="" '([^']+)',="" name:="" '([^']+)'="" \}\}=""\s*/i, (_match, id, name) => {
            void _match
            return `inputProps={{ id: '${id}', name: '${name}' }} `
          }
        )
        .replace(/<div([^>]*)id="(row-[^"]*)"([^>]*)className="([^"]+)"/g, (_match, beforeId, fullId, afterId, classNames) => {
          void _match
          const filteredClasses = classNames.split(/\s+/).filter((cls: string) => !classRemovals.row.includes(cls)).join(' ')
          return filteredClasses ? `<div${beforeId}id="${fullId}"${afterId} className="${filteredClasses}"` : `<div${beforeId}id="${fullId}"${afterId}`
        })
        .replace(/<div([^>]*)id="(container-[^"]*)"([^>]*)className="([^"]+)"/g, (_match, beforeId, fullId, afterId, classNames) => {
          void _match
          const filteredClasses = classNames.split(/\s+/).filter((cls: string) => !classRemovals.container.includes(cls)).join(' ')
          return filteredClasses ? `<div${beforeId}id="${fullId}"${afterId} className="${filteredClasses}"` : `<div${beforeId}id="${fullId}"${afterId}`
        })
        .replace(/<(\w+)([^>]*)>/g, (match, tag, attributes) => {
          if (['img', 'input', 'br', 'hr'].includes(tag)) {
            return `<${tag} ${attributes.trim()} />`
          }
          return match
        })
        .trim()
    }
    const formattedContent = cleanAndFormatHTML(htmlContent)
    // Create a React component template
    const reactComponentContent = `
      import React from 'react';  
      const Form: React.FC = () => {
        return (
          <div className="container whitebg">
            ${formattedContent}
          </div>
        );
      };  
      export default Form;
    `.trim()
    // Create a downloadable file
    try {
      const blob = new Blob([reactComponentContent], { type: 'text/javascript' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = 'Form.tsx'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (error) {
      console.error('Error generating the file:', error)
    }
  }
  const [currentPageTitle, setCurrentPageTitle] = useState(resolvedPageTitle)
  const [pageIcon] = useState('icon-rb-button me-1 color-primary') // Initial icon
  // const [savedForms, setSavedForms] = useState<any[]>([])

  useEffect(() => {
    setCurrentPageTitle(resolvedPageTitle)
  }, [resolvedPageTitle])

  // Load latest published schema from SQL Server on mount
  useEffect(() => {
    if (!formType) return
    loadActiveSchema(formType).then(serverSchema => {
      if (!serverSchema) return
      const parsed = serverSchema as any
      const c = parsed.containersData
      const l = parsed.selectedLayout
      if (c) setContainersData(c)
      if (l) setSelectedLayout(l)
      setSavedSnap(JSON.stringify({ containersData: c ?? [], selectedLayout: l ?? {} }))
    })
  }, [formType])

  // Auto-save schema to localStorage whenever it changes
  useEffect(() => {
    if (!formType) return
    saveSchema(formType, { containersData, selectedLayout })
  }, [containersData, selectedLayout, formType])

  // Re-fetch history whenever publishStatus changes while the modal is open
  useEffect(() => {
    if (!showHistoryModal || !formType) return
    loadSchemaHistory(formType)
      .then(setHistoryVersions)
      .catch(err => {
        console.error('[refresh history]', err)
        setHistoryError(err instanceof Error ? err.message : 'Failed to reload.')
      })
  }, [publishStatus, showHistoryModal, formType])

  const isDirty = useMemo(
    () => JSON.stringify({ containersData, selectedLayout }) !== savedSnap,
    [containersData, selectedLayout, savedSnap]
  )

  const handlePublish = async () => {
    if (!isDirty) {
      setNoChangesMsg('No changes to publish')
      setTimeout(() => setNoChangesMsg(''), 2500)
      return
    }
    if (!formType) {
      handleSaveToFolder()
      return
    }
    setNoChangesMsg('')
    setPublishStatus('publishing')
    const schema = { containersData, selectedLayout }

    // Save to localStorage/IDB (local fallback)
    publishSchemaOnly(formType, schema)

    // Save to SQL Server (source of truth for all users)
    try {
      await publishSchema(formType, schema, currentUser)
      setSavedSnap(JSON.stringify(schema))
      setPublishStatus('success')
      setShowNavigatePrompt(true)
      setTimeout(() => setPublishStatus('idle'), 3000)
    } catch (err) {
      console.error('[handlePublish]', err)
      setPublishStatus('error')
      setTimeout(() => setPublishStatus('idle'), 4000)
    }
  }

  // const handleIconChange = (newIcon: string) => {
  //   console.log('New icon:', newIcon)
  //   setPageIcon(newIcon) // Update the icon in the parent
  // }

  // Load saved forms from SharePoint SAVED_FORMS list
  // useEffect(() => {
  //   const loadSavedForms = async () => {
  //     try {
  //       // Fetch from SharePoint SAVED_FORMS list
  //       const list = await getList(ListNames?.Saved_Components)
  //       if (!(list instanceof Error)) {
  //         const items = await list.items.getAll()

  //         // Parse the SharePoint items and convert to local format
  //         const parsedForms = items.map((item: any) => ({
  //           id: item.ID,
  //           name: item.FormName,
  //           // createdAt: item.Created,
  //           // updatedAt: item.Modified,
  //           // pageTitle: item.PageTitle,
  //           // pageIcon: item.PageIcon,
  //           formSettings: item.FormSettings ? JSON.parse(item.FormSettings) : {},
  //           leftContainers: JSON.parse(item.LeftContainers || '[]'),
  //           rightContainers: JSON.parse(item.RightContainers || '[]'),
  //           selectedLayout: JSON.parse(item.SelectedLayout || '{}'),
  //         }))

  //         setSavedForms(parsedForms)
  //       } else {
  //         throw new Error('Failed to fetch list')
  //       }
  //     } catch (error) {
  //       console.error('Error loading saved forms from SharePoint:', error)
  //       // Fallback to localStorage if SharePoint fetch fails
  //       try {
  //         const saved = JSON.parse(localStorage.getItem('savedForms') || '[]')
  //         setSavedForms(saved)
  //       } catch (localError) {
  //         console.error('Error loading from localStorage:', localError)
  //       }
  //     }
  //   }
  //   loadSavedForms()
  // }, [isForm]) // Reload saved forms whenever a new form is saved

  // Restore a saved form
  // const restoreForm = (formId: string) => {
  //   const formToRestore = savedForms.find((form: any) => form.id === formId)
  //   if (formToRestore) {
  //     setCurrentPageTitle(formToRestore.pageTitle)
  //     setPageIcon(formToRestore.pageIcon)
  //     setFormSettings(formToRestore.formSettings)
  //     setContainersData(formToRestore.leftContainers)
  //     setContainersDataRight(formToRestore.rightContainers)
  //     setSelectedLayout(formToRestore.selectedLayout)
  //     // alert(`Form "${formToRestore.name}" restored successfully!`)
  //   }
  // }

  // Delete a saved form
  // const deleteSavedForm = async (formId: string) => {
  //   const confirmed = window.confirm('Are you sure you want to delete this form?')
  //   if (confirmed) {
  //     try {
  //       // Delete from SharePoint
  //       await pnpDelete(ListNames?.Saved_Components, { ID: formId })

  //       // Update local state
  //       const updatedForms = savedForms.filter((form: any) => form.id !== formId)
  //       localStorage.setItem('savedForms', JSON.stringify(updatedForms))
  //       setSavedForms(updatedForms)
  //       alert('Form deleted successfully!')
  //     } catch (error) {
  //       console.error('Error deleting form:', error)
  //       alert('Error deleting form. Please try again.')
  //     }
  //   }
  // }
  const formTypeLabel = formType ? formType.charAt(0).toUpperCase() + formType.slice(1) : ''

  const handleOpenHistory = async () => {
    if (!formType) return
    setShowHistoryModal(true)
    setHistoryLoading(true)
    setHistoryError(null)
    try {
      const history = await loadSchemaHistory(formType)
      setHistoryVersions(history)
    } catch (err) {
      const msg = err instanceof Error ? err.message : 'Failed to load version history.'
      console.error('[handleOpenHistory]', err)
      setHistoryError(msg)
      setHistoryVersions([])
    } finally {
      setHistoryLoading(false)
    }
  }

  return (
    <>
      <RhyBusAlert
        show={showNavigatePrompt}
        size="md"
        variant="confirm"
        title="Published"
        message={`Form published successfully. Do you want to navigate to the ${formTypeLabel} form to see your changes?`}
        confirmLabel="Yes, Navigate"
        cancelLabel="Stay Here"
        okIcon="icon-rb-checked"
        cancelIcon="icon-rb-close"
        onConfirm={() => {
          setShowNavigatePrompt(false)
          if (formType && FORM_TYPE_ROUTES[formType]) window.location.href = FORM_TYPE_ROUTES[formType]
        }}
        onCancel={() => setShowNavigatePrompt(false)}
      />
      <RhyBusPageHeader
      pageTitle={currentPageTitle}
      pageHeaderIcon={pageIcon}
    />
      <div className='container form-builder'>
        <RhyBusCard 
        cardBody={
          <>
        <div className='d-flex justify-content-between p-2  whitebg border-2 border-radius-2'>
          <div className='d-flex flex-wrap align-items-center gap-2'>
            <RhyBusButton
              aria-label="Preview"
              leftIcon="icon-rb-eye font-10"
              variant="primary"
              className=''
              label={isPreview ? 'Exit Preview' : 'Preview'}
              onClick={handlePreview}
            />
            <RhyBusButton
              label={publishStatus === 'publishing' ? 'Publishing…' : publishStatus === 'success' ? 'Published ✓' : publishStatus === 'error' ? 'Failed ✗' : 'Publish'}
              aria-label="Publish"
              leftIcon="icon-rb-file-up-arrow"
              variant="primary"
              className=''
              disabled={publishStatus === 'publishing'}
              onClick={handlePublish}
            />
            {formType && (
              <RhyBusButton
                label="History"
                aria-label="Version History"
                leftIcon="icon-rb-arrow-rotate-clockwise font-12"
                variant="primary"
                className=''
                onClick={handleOpenHistory}
              />
            )}
            <RhyBusButton
              label="Save"
              aria-label="Save"
              leftIcon="icon-rb-save"
              variant="primary"
              className=''
              onClick={handleSaveOld}
            />
            {noChangesMsg && (
              <span style={{ fontSize: 12, color: '#607D8B', alignSelf: 'center', whiteSpace: 'nowrap' }}>
                <i className="icon-rb-info-circle me-1" aria-hidden="true" />
                {noChangesMsg}
              </span>
            )}
            <label className="flex items-center gap-2">
              {/* <input
                type="checkbox"
                checked={showRightColumn}
                onChange={(e) => setShowRightColumn(e.target.checked)}
                disabled={isPreview}
              /> */}
              <RhyBusInputCheck
                label="Show Right Column"
                type='checkbox'
                checked={showRightColumn}
                onChange={(e) => setShowRightColumn(e.target.checked)}
                disabled={isPreview}
              />
            </label>
          </div>
          <div><RhyBusButton
            label="Export"
            aria-label="Export"
            leftIcon="icon-rb-export font-14"
            className='ms-auto'
            onClick={handleExport}
          /></div>
        </div>
        <div className='row flex-nowrap px-2'>
          <aside className='col-2 flex-auto whitebg border-2 border-radius-2' >
            <h5 className='py-2 mt-1 mb-2 border-bottom bold'>Form Elements</h5>
            {containersData?.length > 0 && <>
              <DraggableChild id="1" label="Text Field" type="Input" isInfo isMandatory />
              <DraggableChild id="2" label="Select Field" type="Select" isInfo isMandatory />
              <DraggableChild id="3" label="Textarea" type="Textarea" isInfo isMandatory />              
              <DraggableChild id="9" label="People Picker" type="PeoplePicker" isInfo isMandatory />
              <DraggableChild id="11" label="Switch" type="Switch" isInfo isMandatory />
              <DraggableChild id="4" label="Checkbox / Radio" dropLabel="Checkbox" type="checkbox" isInfo isMandatory />
              <DraggableChild id="5" label="Upload File" type="uploadfile" isInfo isMandatory />
              <DraggableChild id="6" label="Date Picker" type="DatePicker" isInfo isMandatory />
              <DraggableChild id="10" label="Rich Text Editor" type="RichText" isInfo isMandatory />
              <DraggableChild id="7" label="Button" type="Button" isInfo isMandatory />
              <DraggableChild id="8" label="Content Block" type="Input" isInfo isMandatory preserveLabelOnDrop={false} className="content-block-item" />
            </>}
            <DraggableContainer id="1" />

          </aside>
          <main className='col-8 flex-auto' id="main-content" ref={droppableAreaRef}>
            <div className='row gx-2'>
              
              <div className={showRightColumn && !isPreview ? 'col-9 mt-0' : 'col-12 mt-0'}>
                {isPreview && previewForm ? previewForm : (
                  <DroppableArea
                    column="left"
                    selectedRowId={selectedRowId}
                    selectedContainer={selectedContainer}
                    setSelectedContainer={setSelectedContainer}
                    layout={layout}
                    setChildrenLengths={setChildrenLengths}
                    setChildSelects={setChildSelects}
                    formSettings={formSettings}
                    changedLabel={changedLabel}
                    setSelectChilds={setSelectChild}
                    clickedId={clickedId}
                    containerClassName={handleAlign}
                    containersData={containersData}
                    setContainersData={setContainersData}
                    containerId={containerId}
                    selectedChildId={selectedChildId}
                    setSelectedChildId={setSelectedChildId}
                    setSelectedWholeRowId={setSelectedWholeRowId}
                    selectedWholeRowId={selectedWholeRowId}
                    setSelectedSubChild={setSelectedSubChild}
                    setSelectedType={setSelectedType}
                    selectedLayout={selectedLayout}
                    setSelectedLayout={setSelectedLayout}
                  />
                )}
              </div>

              {/* Right Column (col-4) */}
              {showRightColumn && !isPreview && (
                <div className='col-3'>
                  <DroppableArea
                    column="right"
                    selectedRowId={selectedRowId}
                    selectedContainer={selectedContainer}
                    setSelectedContainer={setSelectedContainer}
                    layout={layout}
                    setChildrenLengths={setChildrenLengths}
                    setChildSelects={setChildSelects}
                    formSettings={formSettings}
                    changedLabel={changedLabel}
                    setSelectChilds={setSelectChild}
                    clickedId={clickedId}
                    containerClassName={handleAlign}
                    containersData={containersDataRight}
                    setContainersData={setContainersDataRight}
                    containerId={containerId}
                    selectedChildId={selectedChildId}
                    setSelectedChildId={setSelectedChildId}
                    setSelectedWholeRowId={setSelectedWholeRowId}
                    selectedWholeRowId={selectedWholeRowId}
                    setSelectedSubChild={setSelectedSubChild}
                    setSelectedType={setSelectedType}
                    selectedLayout={selectedLayout}
                    setSelectedLayout={setSelectedLayout}
                  />
                </div>
              )}
            </div>
          </main>
          <aside className='col-2 flex-auto whitebg border-2 border-radius-2 pb-2'>
            <h5 className='border-bottom py-2 mt-1 mb-1 bold'>General</h5>
            {selectedContainer !== null && !isPreview && (
              <>
                <LayoutSelector onLayoutChange={handleLayoutChange} selectedLayout={layout} previousSelectedLayout={previousSelectedLayout} />
                <div className="dividerdashed"></div>
                <h5 className='border-bottom py-2 mt-1 mb-1 font-12 bold'>Custom Theme Options</h5>
                <div className='row g-1'>
                  <RhyBusCustomSelect id='gutterspace'
                    labelClassName="font-12 editable-label"
                    label='Gutter Space'
                    options={gutterspace}
                    size='sm'
                    wrapperClassName="col-12 col-xxl-6 customoptions"
                    value={gutterspace.find(o => o.value === (formSettings.gutterspace as any)?.value) || null}
                    onChange={(value: any) => handleSettingChange('gutterspace', value)}
                  />
                  <RhyBusCustomSelect id='formsize'
                    labelClassName="font-12 editable-label"
                    label='Form Size'
                    options={formSizes}
                    size='sm'
                    wrapperClassName="col-12 col-xxl-6 customoptions"
                    value={formSizes.find(o => o.value === (formSettings.formsize as any)?.value) || null}
                    onChange={(value: any) => handleSettingChange('formsize', value)}
                  />
                  {/* <RhyBusCustomSelect id='fontfamily'
                    labelClassName="font-12 editable-label"
                    label='Font Family'
                    options={fontFamily.map(o => ({ value: o.value, label: o.value }))}
                    onChange={(value: any) => handleSettingChange('fontfamily', value)}
                  /> */}
                  <RhyBusCustomSelect id='fontcolor'
                    labelClassName="font-12 editable-label"
                    label='Font Color'
                    options={ButtonColorFilters as any}
                    size='sm'
                    wrapperClassName="col-12 col-xxl-6 customoptions"
                    value={ButtonColorFilters.find((o: any) => o.value === (formSettings.fontcolor as any)?.value) || null}
                    components={{ MenuList: ({ children, innerRef, innerProps }: any) => <div ref={innerRef} {...innerProps} className={`${innerProps?.className || ''} color-picker-menu`}>{children}</div> }}
                    onChange={(value: any) => handleSettingChange('fontcolor', value)}
                  />
                  <RhyBusCustomSelect id='fontsize'
                    labelClassName="font-12 editable-label"
                    label='Font Size'
                    options={fontSizes}
                    size='sm'
                    menuPlacement="auto"
                    wrapperClassName="col-12 col-xxl-6 customoptions"
                    value={fontSizes.find((o: any) => o.value === (formSettings.fontsize as any)?.value) || null}
                    onChange={(value: any) => handleSettingChange('fontsize', value)}
                  />
                  {/* <RhyBusCustomSelect id='bordercolor'
                    labelClassName="font-12 editable-label"
                    label='Border Color'
                    options={borderColors.map(o => ({ value: o.value, label: o.value }))}
                    // options={borderColors}
                    // useFormattedOptions={true}
                    menuPlacement="auto"
                    wrapperClassName="col-12 col-xl-6 customoptions"
                    onChange={(value: any) => handleSettingChange('bordercolor', value)}
                  /> */}
                  {/* <RhyBusCustomSelect id='bordertype'
                    labelClassName="font-12 editable-label"
                    label='Border Type'
                    options={borderType}
                    // useFormattedOptions={true}
                    menuPlacement="auto"
                    // formClassName="form-vertical my-1 col-12 col-xl-6 customoptions"
                    onChange={(value: any) => handleSettingChange('bordertype', value)}
                  /> */}

                  {/* <RhyBusCustomSelect id='borderradius'
                    labelClassName="font-12 editable-label"
                    label='Border Radius'
                    options={borderRadius}
                    // useFormattedOptions={true}
                    menuPlacement="auto"
                    wrapperClassName="col-12 col-xl-6 customoptions"
                    onChange={(value: any) => handleSettingChange('borderradius', value)}
                  /> */}
                </div>

                {/* <div className="dividerdashed"></div>
                <div className='d-flex'>
                <h5 className='my-1'>Align Items</h5>
                <div className='d-flex gap-1 mt-1 mb-2 justify-content-center'>
                  <Buttons
                    label="Align start"
                    aria-label="Align start"
                    icon={'icon-rb-align-left pe-1 font-16 bold'}
                    className='color-primary font-0'
                    onClick={() => {AlignHandler('leftAlign')}}
                  />
                  <Buttons
                    label="Align Center"
                    aria-label="Align center"
                    icon={'icon-rb-align-center pe-1 font-16 bold'}
                    className='color-primary font-0'
                    onClick={() => {AlignHandler('centerAlign')}}
                  />
                  <Buttons
                    label="Align end"
                    aria-label="Align end"
                    icon={'icon-rb-align-right pe-1 font-16 bold'}
                    className='color-primary font-0'
                    onClick={() => {AlignHandler('rightAlign')}}
                  />
                </div>
                </div> */}
              </>
            )}
            {selectedContainer === null && selectChild && <ElementOptions selectedRowId={selectedRowId} containers={containersData} child={child} selectChild={selectChild} onUpdate={onUpdate} onClicked={onClicked} containerId={containerId} />}
          </aside>
        </div>
        </>
        }/>
      </div>


      {isModalPopup && <Modalpopup
        isOpen={isModalPopup}
        // isClose={modalpopupClose}
        headerContent={
          <div className='d-flex w-100 justify-content-between py-2 px-3 border-bottom-1 align-items-center'>
            <h5 className='bold'>Preview</h5>
            <RhyBusButton
              // label="close"
              aria-label="close"
              leftIcon="icon-rb-close font-10"
              className=''
              onClick={modalpopupClose}
            />
          </div>
        }
        bodyContent={
          <div id="preview" className="preview-area" dangerouslySetInnerHTML={{ __html: previewContent }}>

          </div>
        }
        popupbodyclass='row'
      />
      }

      {showHistoryModal && (
        <Modalpopup
          isOpen={showHistoryModal}
          bodyContent={
            <VersionHistoryPanel
              formType={formType ?? ''}
              versions={historyVersions}
              loading={historyLoading}
              error={historyError ?? undefined}
              currentUser={currentUser}
              onClose={() => setShowHistoryModal(false)}
              onRestoreSuccess={(schema) => {
                if (schema.containersData) setContainersData(schema.containersData)
                if (schema.selectedLayout) setSelectedLayout(schema.selectedLayout)
                setShowHistoryModal(false)
              }}
            />
          }
        />
      )}

    </>
  )
}
export default PageBuilder
